import React from 'react';
import Internships from '../components/UI/Internships';

const InternshipsPage = () => {
  return (
    <div className="internships-page">
      <Internships />
    </div>
  );
};

export default InternshipsPage; 